module.exports = __webpack_public_path__ + "static/img/ahlenculs.148211e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ahlenculs.png
// module id = 28
// module chunks = 0